import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useQuiz } from './hooks/useQuiz';
import { QuizIntro } from './components/QuizIntro';
import { QuizQuestion } from './components/QuizQuestion';
import { QuizLoading } from './components/QuizLoading';
import { QuizResult } from './components/QuizResult';
import { QuizCTABridge } from './components/QuizCTABridge';
import { Dashboard } from './pages/Dashboard';
function getRoute(): string {
  const params = new URLSearchParams(window.location.search);
  if (params.get('view') === 'dash') return 'dash';
  const hash = window.location.hash;
  if (hash === '#/dash' || hash === '#dash') return 'dash';
  if (window.location.pathname === '/dash' || window.location.pathname === '/dash/') return 'dash';
  return 'quiz';
}
export function App() {
  const [route, setRoute] = useState(getRoute);
  useEffect(() => {
    const onRouteChange = () => setRoute(getRoute());
    window.addEventListener('hashchange', onRouteChange);
    window.addEventListener('popstate', onRouteChange);
    return () => {
      window.removeEventListener('hashchange', onRouteChange);
      window.removeEventListener('popstate', onRouteChange);
    };
  }, []);
  if (route === 'dash') {
    return <Dashboard data-id="element-0" />;
  }
  return <QuizApp data-id="element-1" />;
}
function QuizApp() {
  const {
    step,
    questionIndex,
    currentQuestion,
    totalQuestions,
    progress,
    result,
    startQuiz,
    answerQuestion,
    goToResult,
    goToCTA,
    restart
  } = useQuiz();
  return <div className="min-h-screen w-full relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0a0f 0%, #0c1222 50%, #0a0a0f 100%)'
  }} data-id="element-2">
      <div className="fixed inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(0,212,255,0.06) 0%, transparent 70%)'
    }} data-id="element-3" />
      <div className="fixed inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 40% 50% at 80% 80%, rgba(245,158,11,0.03) 0%, transparent 70%)'
    }} data-id="element-4" />

      <div className="relative z-10" data-id="element-5">
        <AnimatePresence mode="wait" data-id="element-6">
          {step === 'intro' && <QuizIntro key="intro" onStart={startQuiz} data-id="element-7" />}

          {step === 'question' && currentQuestion && <QuizQuestion key={`q-${questionIndex}`} question={currentQuestion} questionIndex={questionIndex} totalQuestions={totalQuestions} progress={progress} onAnswer={answerQuestion} data-id="element-8" />}

          {step === 'loading' && <QuizLoading key="loading" onComplete={goToResult} data-id="element-9" />}

          {step === 'result' && result && <QuizResult key="result" result={result} onContinue={goToCTA} data-id="element-10" />}

          {step === 'cta' && <QuizCTABridge key="cta" onRestart={restart} data-id="element-11" />}
        </AnimatePresence>
      </div>
    </div>;
}